import { render } from "./CategoryForm.vue?vue&type=template&id=dce22ed4"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"
script.render = render

export default script